import { useTrackedCustomSearchParams } from 'common/hooks/customSearchParams';
import { SegmentEvent } from 'services/helpers/segment';
import { ADD_SHIPMENTS_QUERY_PARAMS } from '../params';

export const useFilterSearchParams = (resetPageParamOnUpdate = false) => {
  return useTrackedCustomSearchParams(
    SegmentEvent.ShipmentsAddTableFilterUsed,
    ADD_SHIPMENTS_QUERY_PARAMS,
    resetPageParamOnUpdate
  );
};
